import React, { useEffect, useState } from 'react';
import apiInstance from '../../../utils/axios';

function Banner_03() {
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const response = await apiInstance.get('banners/');
        // Handle both direct array and paginated response
        const bannersData = Array.isArray(response.data) ? response.data : (response.data.results || []);
        setBanners(bannersData);
      } catch (error) {
        console.error('Error fetching banners:', error);
      }
    };

    fetchBanners();
  }, []);

  const handleBannerClick = (link) => {
    if (link) {
      window.location.href = link;
    }
  };

  const banner = banners.length > 0 ? banners[0] : null;

  if (!banner) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '200px', marginTop: '40px' }}>
        <p className="text-muted">No hay banners disponibles</p>
      </div>
    );
  }

  return (
    <div style={{
      maxWidth: '1200px',
      margin: '40px auto',
      padding: '32px',
      backgroundColor: 'white',
      borderRadius: '12px',
      boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
      border: '1px solid #f0f0f0',
      boxSizing: 'border-box',
    }}>
      <div
        className="relative flex flex-col overflow-hidden rounded-xl bg-gradient-to-br from-gray-900 to-gray-800 p-4 text-white shadow-xl md:flex-row md:items-center md:justify-between md:p-6 cursor-pointer"
        onClick={() => handleBannerClick(banner.link)}
      >
      {/* Pattern overlay */}
      <div className="absolute inset-0 opacity-10">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="grid" width="20" height="20" patternUnits="userSpaceOnUse">
              <path d="M 20 0 L 0 0 0 20" fill="none" stroke="white" strokeWidth="1" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" />
        </svg>
      </div>
      {/* Content */}
      <div className="z-10 space-y-3 md:w-3/5">
        <div
          className="inline-block rounded-lg bg-blue-500 px-2 py-1 text-xs font-semibold tracking-wider text-white uppercase md:px-3">
          {banner.badge || 'New in Stock'}
        </div>
        <h2
          className="text-2xl leading-tight font-bold tracking-tight md:text-3xl lg:text-4xl">
          {banner.title_translated || banner.title} <span className="text-blue-400">{banner.subtitle || ''}</span>
        </h2>
        <p className="max-w-xl text-sm text-gray-300 md:text-base">
          {banner.description_translated || banner.description || 'Experience the best products with us.'}
        </p>
        <div className="flex flex-wrap gap-2 pt-2 md:gap-3 md:pt-2">
          <button
            className="rounded-md bg-blue-500 px-4 py-2 text-sm font-medium transition-all hover:bg-blue-600 md:px-6 md:py-2 md:text-base">
            {banner.button_text || 'Shop Now'}
          </button>
          <button
            className="rounded-md border border-white/30 bg-transparent px-4 py-2 text-sm font-medium transition-all hover:bg-white/10 md:px-6 md:py-2 md:text-base">
            {banner.secondary_button || 'View Specs'}
          </button>
        </div>
      </div>
      {/* Image */}
      <div className="relative z-10 mt-4 h-40 w-full md:mt-0 md:h-64 md:w-2/5">
        <div
          className="absolute -top-2 -right-2 h-40 w-40 rounded-full bg-blue-500/30 blur-xl md:-top-4 md:-right-4 md:h-60 md:w-60"></div>
        <div className="relative h-full w-full">
          <img
            src={banner.image}
            alt={banner.title_translated || banner.title}
            className="drop-shadow-2xl w-full h-full object-cover rounded-lg"
          />
        </div>
      </div>
    </div>
    </div>
  );
}

export default Banner_03;
